import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellText from "ds/components/Table/Row/CellText";
import { ManagedUserGroupIntegration } from "types/generated";
import { pluralize } from "shared/Pluralize";

const SlackTableSpacesCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroupIntegration>) => {
  const spacesCount = integration.accessRules?.length ?? 0;

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{`${spacesCount} ${pluralize("space", spacesCount)}`}</TableCellText>
    </TableSimpleCell>
  );
};

export default SlackTableSpacesCell;
